// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M21 3A1 1 0 0 1 22 4V11H20V5H4V19H10V21H3A1 1 0 0 1 2 20V4A1 1 0 0 1 3 3ZM21 13A1 1 0 0 1 22 14V20A1 1 0 0 1 21 21H13A1 1 0 0 1 12 20V14A1 1 0 0 1 13 13Z"/>';

/** Picture in Picture (media). */
const icon: IconData = {
  id: "pip",
  name: "Picture in Picture",
  category: "media",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M21 3A1 1 0 0 1 22 4V11H20V5H4V19H10V21H3A1 1 0 0 1 2 20V4A1 1 0 0 1 3 3ZM21 13A1 1 0 0 1 22 14V20A1 1 0 0 1 21 21H13A1 1 0 0 1 12 20V14A1 1 0 0 1 13 13ZM20 15H14V19H20Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M21.39 13.08L21.71 13.29 21.92 13.61 22 14V20L21.92 20.39 21.71 20.71 21.39 20.92 21 21H13L12.61 20.92 12.29 20.71 12.08 20.39 12 20V14L12.08 13.61 12.29 13.29 12.61 13.08 13 13H21ZM21.39 3.08L21.71 3.29 21.92 3.61 22 4V11H20V5H4V19H10V21H3L2.61 20.92 2.29 20.71 2.08 20.39 2 20V4L2.08 3.61 2.29 3.29 2.61 3.08 3 3H21Z"/></g><path d="M21 3A1 1 0 0 1 22 4V11H20V5H4V19H10V21H3A1 1 0 0 1 2 20V4A1 1 0 0 1 3 3ZM21 13A1 1 0 0 1 22 14V20A1 1 0 0 1 21 21H13A1 1 0 0 1 12 20V14A1 1 0 0 1 13 13ZM20 15H14V19H20Z"/>',
    },
  },
  animation: () => import("../animations/pip.js"),
};

export default icon;
